angular.module 'zc.users'

.controller 'UsersSignInCtrl', ($scope, $state, $translate, Page, Devise, Project, afterLoginHandler, localStorageService, $window, $location, returnUrl) ->
  $scope.user = { email: "", password: "", remember_me: true}
  $scope.enableAuth0 = $window.ZC_CONFIG.ENABLE_AUTH0

  # To ensure user to read updated angular app.
  $scope.$on '$locationChangeSuccess', (a)->
    # Devise.currentUser == undefined means never logined
    if Devise.currentUser != undefined and $window.location.pathname == '/users/sign_in'
      localStorageService.clearAll()
      $window.location.reload()

  $translate('users.controllers.signInController.login').then (translation) ->
    Page.setTitle translation

  Page.setBodyClass 'account-bg'
  $scope.login = (user) ->
    Devise.signIn(user.email, user.password, user.remember_me).then (res) ->
      afterLoginHandler.handle(res)



// WEBPACK FOOTER //
// ./src/zenclerk_modules/users/controllers/sign_in_controller.js.coffee